import React, { Component } from 'react';

import styles from './CreateAppointment.css';
import Headline from "../Headline/Headline";
import { Row, Col, Input, Label, FormGroup } from 'reactstrap';
import Button from '../Button/Button';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils, {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';
import moment from 'moment'
import TimePicker from 'rc-time-picker';

const showSecond = true;
const str = showSecond ? 'HH:mm:ss' : 'HH:mm';

export default class CreateAppointment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      date: new Date(),
      time: moment(),
      repeat: false,
      numberDoctors: "",
      repeatVal: null,
      lastDate: null
    };

    this.handleFormSubmit = this.handleFormSubmit.bind(this)
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleFormSubmit(e) {
    e.preventDefault();
    const { submitAction } = this.props;
    const { time, date, repeatVal } = this.state;

    let timestampStr = moment(date).format("YYYY-MM-DD ");
    timestampStr += time.format('HH:mm:ss');

    //console.log("STR: " + timestampStr);

    submitAction(moment(timestampStr).unix(), repeatVal);
  }

  render() {
    const { date, time, repeat, repeatVal, lastDate, timeError, repeatError, numberDoctorsError } = this.state;

    return (
      <div className={styles.wrapper}>
        <Headline small>Termin erstellen</Headline>

        <form className={styles.form} onSubmit={this.handleFormSubmit}>

          <Row>
            <Col>
              <DayPickerInput
                className={styles.lastInput}
                placeholder="Wann?"
                value={formatDate(date, 'LL', 'de')}
                onDayChange={day => {
                  this.setState({
                    date: day.getTime()
                  });
                }}
                formatDate={formatDate}
                parseDate={parseDate}
                dayPickerProps={{
                  locale: 'de',
                  localeUtils: MomentLocaleUtils,
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <TimePicker
                showSecond={false}
                allowEmpty={false}
                defaultValue={moment()}
                className={styles.timePicker}
                onChange={(value) => {
                  this.setState({
                    time: value
                  })
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <label>
                <input
                  type="checkbox"
                  className={styles.checkbox}
                  onChange={(event) => this.setState({ repeat: event.target.checked })}
                /> Termin wöchentlich wiederholen
              </label>
            </Col>
          </Row>

          {
            repeat && <Row>
              <Col>
                <FormGroup>
                  <Input
                    type="number"
                    placeholder="Anzahl der Wochen"
                    onChange={(event) => {
                      const {date} = this.state;

                      const val = event.target.value;
                      let lastDate = moment(date).add(event.target.value, 'weeks').format('DD.MM.YYYY');
                      if(val === '') {
                        lastDate = null;
                      }

                      this.setState({
                        repeatVal: event.target.value,
                        lastDate,
                      })
                    }}
                    value={repeatVal}
                  />
                </FormGroup>
              </Col>
            </Row>
          }

          {
            lastDate !== null && <Row>
              <Col>
                <span className={styles.lastDate}>Letzter Termin: {lastDate}</span>
              </Col>
            </Row>
          }

          <Row>
            <Col>
              <Button submit pullRight>Termin erstellen</Button>
            </Col>
          </Row>

        </form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CreateAppointment/CreateAppointment.js